import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[txtbDragHandle]',
  standalone: false,
})
export class DragHandleDirective {
  constructor(public elementRef: ElementRef) {}
}
